import logger from "@next/core-logger"
import type {AxiosError} from "axios"
import axios from "../../utils/axios"
import ProductsApi from "../../config/api/products"
import {ITEMS_STRING_QUERY_STRING} from "../../config/constants"
import {urlSanitiser} from "../../utils/httpUrlTrimmer"

const getProductSummaryAggregationApi = ProductsApi("getProductSummaryAggregation")

export const getProductSummaryAggregation = async (
    headers,
    itemsString: string,
    apiProxyVersion: string,
    siteUrl: string,
): Promise<string> => {
    try {
        const response = await axios({
            method: getProductSummaryAggregationApi.method,
            url: `${urlSanitiser(siteUrl)}${getProductSummaryAggregationApi.localEndpoint(apiProxyVersion)}`,
            headers,
            params: {
                [ITEMS_STRING_QUERY_STRING]: itemsString,
            },
        })
        return response.data
    } catch (error) {
        const ex = error as AxiosError
        if (ex.response) {
            // Axios interceptors log this error already
            throw ex
        }
        logger.error(ex)
        throw ex
    }
}
